import { getConsentManifestUrl } from '@/utils/helpers/environment';

export interface ConsentManifest {
  tcConsentVersion?: string;
  ppConsentVersion?: string;
}

/**
 * Fetch the consent versions manifest published by Magnolia in the DAM.
 *
 * The signup flow relies on this to mirror the user's PP acceptance into a
 * cross-subdomain cookie so the shell SPA does not re-prompt. The fetch is
 * intentionally tolerant: any failure (network, non-200, malformed JSON,
 * unexpected shape) returns `null` so the signup can proceed uninterrupted
 * — the shell will simply re-prompt as it does today.
 */
export async function fetchConsentManifest(): Promise<ConsentManifest | null> {
  try {
    const response = await fetch(getConsentManifestUrl(), {
      cache: 'no-store',
      credentials: 'omit',
    });
    if (!response.ok) return null;

    const data: unknown = await response.json();
    if (!data || typeof data !== 'object') return null;

    const { tcConsentVersion, ppConsentVersion } = data as Record<
      string,
      unknown
    >;
    return {
      tcConsentVersion:
        typeof tcConsentVersion === 'string' ? tcConsentVersion : undefined,
      ppConsentVersion:
        typeof ppConsentVersion === 'string' ? ppConsentVersion : undefined,
    };
  } catch {
    return null;
  }
}
